import React, { useRef, useCallback } from 'react';
import { throttle } from '@thd-olt-functional/utils';

import { usePromoModel } from '../../contexts/PromoModelProvider';
import { usePromoCart } from '../../contexts/PromoCartProvider';
import { usePromoPresentation } from '../../contexts/PromoPresentationProvider';
import { PromoHeader } from '../promo-header/PromoHeader';
import { PromoList } from '../promo-list/PromoList';
import { PromoSidecar } from '../promo-sidecar/PromoSidecar';
import './PromoDrawer.scss';

export const PromoDrawer = () => {
  const {
    isDrawerOpen,
    setIsDrawerOpen,
    setHideImages,
    promoListRef
  } = usePromoPresentation();
  const { isBmsm } = usePromoModel();
  const { isPromoAchieved, currentPromoTier } = usePromoCart();
  const startingPosition = useRef(0);

  const showGoToCartCta = currentPromoTier > 0 && isBmsm && !isPromoAchieved;

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const showOrHideImages = useCallback(throttle(50, () => {
    const currentPosition = promoListRef?.current?.firstChild?.getBoundingClientRect().top;
    const distanceMoved = currentPosition - startingPosition.current;
    if (Math.abs(distanceMoved) <= 80) return; // ignore small motions
    if (distanceMoved > 0) setHideImages(false);
    if (distanceMoved < 0) setHideImages(true);
    startingPosition.current = currentPosition;
  }), [promoListRef, setHideImages, startingPosition]);

  return (
    <PromoSidecar
      useSidecarMask
      useSidecarCart={showGoToCartCta}
      isSidecarOpen={isDrawerOpen}
      setIsSidecarOpen={setIsDrawerOpen}
    >
      <article
        className="promo-drawer"
        data-testid={`${isDrawerOpen ? 'promo-drawer--open' : 'promo-drawer--closed'}`}
        onScroll={isDrawerOpen ? showOrHideImages : undefined}
      >
        <PromoHeader />
        <PromoList />
      </article>
    </PromoSidecar>
  );
};

PromoDrawer.displayName = 'PromoDrawer';
